<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chp" id="_idParaDest-8"><a id="_idTextAnchor007"></a></h1>
<p class="epi"><i class="italic">Old is the tree, and the fruit good</i></p>
<p class="epi"><i class="italic">Very old and thick the wood.</i></p>
<p class="epi"><i class="italic">Woodsman, is your courage stout?</i></p>
<p class="epi"><i class="italic">Beware! The root is wrapped about</i></p>
<p class="epi"><i class="italic">Your mother’s heart, your father’s bones;</i></p>
<p class="epi"><i class="italic">And like the mandrake comes with groans.</i></p>
<p class="right">—Robert Louis Stevenson, <i class="italic">Fables</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Headhunter-8.vue?540f142a